"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const selectors_1 = require("@/store/ducks/systems/selectors");
const systems_1 = require("@/store/ducks/systems");
const Toast_1 = __importDefault(require("@/components/Toast"));
function SystemsToast() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const systemToastStatus = (0, react_redux_1.useSelector)(selectors_1.systemToastSelector);
    react_1.default.useEffect(() => {
        let close = undefined;
        if (systemToastStatus?.isOpen) {
            close = setInterval(() => {
                dispatch((0, systems_1.closeSystemToast)());
            }, 3000);
        }
        return () => clearInterval(close);
    }, [systemToastStatus?.isOpen, systems_1.closeSystemToast, dispatch]);
    const onClose = react_1.default.useCallback((event, reason) => {
        if (reason === "clickaway") {
            dispatch((0, systems_1.closeSystemToast)());
        }
    }, [systems_1.closeSystemToast, dispatch]);
    return (react_1.default.createElement(Toast_1.default, { closeText: "X", isOpen: Boolean(systemToastStatus?.isOpen), onClose: onClose, severity: systemToastStatus?.status, anchorOrigin: { horizontal: "right", vertical: "top" }, message: systemToastStatus?.message }));
}
exports.default = SystemsToast;
